import _ from 'lodash';
import { v4 as uuid } from 'uuid';
import danger from '@/helpers/danger'

const progress = {
  namespaced: true,
  state: {
    progressTracks: [],
    pinnedProgressTrackUUID: '',
  },

  getters: {
    allTracks(state) {
      return _.orderBy(state.progressTracks, ['createdAt'], ['desc']);
    },
    progressTracks(state) {
      // TODO: use _.chain()
      const progress = _.filter(state.progressTracks, (t) => { return !t.isVow  })
      const orderedProgress = _.orderBy(progress, ['createdAt', 'desc']);
      return orderedProgress
    },
    vowTracks(state) {
      const vows = _.filter(state.progressTracks, (t) => { return t.isVow  })
      const orderedVows = _.orderBy(vows, ['createdAt', 'desc']);
      return orderedVows
    },
    progressTrackByUUID: state => uuid => {
      return _.find(state.progressTracks, { uuid: uuid }) || null;
    },
    progressIsPinned(state) {
      return state.pinnedProgressTrackUUID != '';
    },
    pinnedProgressTrack(state, getters) {
      return getters.progressTrackByUUID(state.pinnedProgressTrackUUID);
    },
  },

  mutations: {
    createProgressTrack(state, trackArg) {
      const track = {
        uuid: uuid(),
        name: trackArg.name,
        notes: trackArg.notes,
        ticks: 0,
        rank: danger.dangerLevels[trackArg.rank],
        isVow: trackArg.isVow,
        createdAt: new Date().getTime(),
      }
      state.progressTracks.push(track);
    },
    updateProgressTrack(state, updatedTrack) {
      // find track
      const originalTrack = _.find(state.progressTracks, { uuid: updatedTrack.uuid });
      // overwrite with the updated one
      Object.assign(originalTrack, updatedTrack);
    },
    setPinnedProgressTrackUUID(state, uuid) {
      state.pinnedProgressTrackUUID = uuid
    },
    clearPinnedProgressTrackUUID(state) {
      state.pinnedProgressTrackUUID = ''
    },
    addTickTo(state, uuid) {
      const track = _.find(state.progressTracks, { uuid: uuid });
      if (track.ticks < 40) {
        track.ticks += 1;
      }
    },
    removeTickFrom(state, uuid) {
      const track = _.find(state.progressTracks, { uuid: uuid });
      if (track.ticks > 0) {
        track.ticks -= 1;
      }
    },
    deleteProgressTrack(state, track) {
      var index = state.progressTracks.findIndex(t => t.uuid === track.uuid);
      state.progressTracks.splice(index, 1);
    },
  },

  actions: {
    deleteProgressTrack({getters, dispatch, commit}, track) {
      if (getters.pinnedProgressTrackUUID === track.uuid) {
        dispatch('clearPinnedProgressTrack')
      }
      commit('deleteProgressTrack', track)
    },
    updateProgressTrack({commit}, track) {
      commit('updateProgressTrack', track)
    },

    addTick({commit}, payload) {
      commit('addTickTo', payload.uuid);
    },

    removeTick({commit}, payload) {
      commit('removeTickFrom', payload.uuid);
    },

    pinProgressTrack({commit}, payload) {
      commit('setPinnedProgressTrackUUID', payload.uuid);
    },
    clearPinnedProgressTrack({commit}) {
      commit('clearPinnedProgressTrackUUID');
    },

    createProgressTrack({commit}, payload) {
      commit('createProgressTrack', {
        name: payload.name,
        rank: payload.rank,
        notes: payload.notes,
        isVow: payload.isVow,
      });
    },
  },
}

export default progress
